__turbopack_context__.v({
  "className": "Fotz9G_className",
  "variable": "Fotz9G_variable",
});
